module.exports = __webpack_public_path__ + "static/img/akum_800_200.89af921.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_200.svg
// module id = rIfN
// module chunks = 1